import * as React from "react";
import Card from "../core/Card";
import Button from "../core/Button";
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import {useState, useEffect} from "react";

interface KeyFormProps{
  setGroups: Function;
  setShowKeyNew?: Function;
  setShowKeyEdit?: Function;
  setTools: Function;
  setCourses: Function;
  setFolders: Function;
  name:string;
  desc:string;
  setName: Function;
  setDesc: Function;
  loading: boolean;
  setLoading: Function
  tools: any;
  tools2: any;
  courses: any;
  courses2: any;
  folders: any;
  folders2: any;
  power: Function;
  toggle_tool: Function;
  toggle_course: Function;
  toggle_folder: Function;
  handleSave:Function;
  init: Function;
}
function KeyForm(props:KeyFormProps){

  useEffect(() => props.init(), [])

  return (
    <Card title={"Access"}>
      <div className="permission-row">
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>Name</label>
              <input type="text" className="form-control" value={props.name} onChange={(e) => props.setName(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Descritpion</label>
              <textarea rows={3} className="form-control" value={props.desc} onChange={(e) => props.setDesc(e.target.value)} />
            </div>
            <div>
              <Button 
                loading={props.loading}
                color="primary"
                onClick={() => props.handleSave()}
              >
                Save
              </Button>
            </div>            
          </div>
        </div>
      </div>        
      <AccessResource 
        label="Tools" 
        resources={props.tools2} 
        type="tool" 
        power={props.power} 
        toggle={props.toggle_tool}
      />
      <AccessResource 
        label="Courses" 
        resources={props.courses2} 
        type="course" 
        power={props.power} 
        toggle={props.toggle_course} 
      />
      <AccessResource 
        label="Resource Folders" 
        resources={props.folders2} 
        type="folder"  
        power={props.power} 
        toggle={props.toggle_folder} 
      />
    </Card>
  )
}

interface ARProps{
  label:string
  resources: any
  type:string;
  power:Function;
  toggle:Function;
}

function AccessResource(props:ARProps){
  const [choice, setChoice] = useState('none')
  const [toggleAll, setToggleAll] = useState(false)
  useEffect(() => {
    if(toggleAll){
      if(choice == 'all'){
        props.power(props.type, true)
      }
      else if(choice == 'none'){
        props.power(props.type, false)
      }
    }
  }, [choice])
  return (
    <div className="permission-row">
      <div className="row" style={{paddingBottom:'20px'}}>
        <div className="col-lg-4">
          <label>{props.label}</label>
          <select 
            className="form-control" 
            value={choice} 
            onChange={ (e) => {
              setToggleAll(true)
              setChoice(e.target.value)
            }}
          >
            <option value="all">Toggle All {props.label} On</option>
            <option value="none">Toggle All {props.label} Off</option>
          </select>          
        </div>
      </div>
      {props.resources.map((resource, i) => {
        return (
          <div className="row" key={i}>
            { resource.map((r) => {
              return <Toggle 
                key={r.id} 
                id={r.id} 
                name={r.name} 
                access={r.access} 
                toggle={props.toggle} 
                choice={choice}
              />
            })}
          </div>
        )
      })}
    </div>
  )
}



interface toggleProps{
  id:number;
  name:string;
  access:boolean;
  toggle:Function;
  choice: string;
}
function Toggle(props:toggleProps){

  return (
    <div className="col-lg-3 text-center" style={{paddingTop:'15px', paddingBottom:'15px', border:'1px dashed #e8e8e8'}} key={props.id}>
      <div style={{minHeight:'45px'}}>
        <label>{props.name}</label>
      </div>
      <div>
        <BootstrapSwitchButton 
          key={props.id} 
          checked={props.access} 
          width={120} 
          onChange={(checked) => {
            props.toggle(props.id, checked)
          }}
        />
      </div>
    </div> 
  )
}

export default KeyForm


// WEBPACK FOOTER //
// ./app/javascript/components/permissions/KeyForm.tsx